import { ILiquidationFileInfo, ILiquidationSummary } from 'src/interfaces/sharedContribution';
import apiPromotionsBFF from 'src/config/api/apiPromotionsBFF';
import apiStoresBOBFF from 'src/config/api/apiStoreBFF';
import {
  INewPromotionResponse,
  IPromotionDetailsResponse,
  IPromotionsResponse,
  IStoresPromotionResponse
} from 'src/interfaces/promotions';
import { IServiceParams } from 'src/interfaces/services';

import {
  SOURCE_BO,
  loadUrlParamsFromObject,
  PROMOTIONS_PATH,
  getCuitList,
  COMPANY_POSITIONS_PATH,
  LIQUIDATION_SUMMARY_PATH
} from '../../utils';

const findAll = async ({ filterUrlParams, pagination = { page: 1, limit: 6 } }: IServiceParams) => {
  const filterParams = loadUrlParamsFromObject(filterUrlParams);
  const paginationParams = loadUrlParamsFromObject(pagination);
  let url = `${PROMOTIONS_PATH}?source=${SOURCE_BO}&${paginationParams}`;

  if (filterParams) {
    url = `${url}&${filterParams}`;
  }
  const response = await apiStoresBOBFF.get<IPromotionsResponse>(url);
  return response.data;
};

const DEFAULT_PAGINATION: { page: number; limit: number } = { page: 1, limit: 6 };

const findDetails = async (promoId, companyId, pagination = DEFAULT_PAGINATION) => {
  const paginationParams = loadUrlParamsFromObject(pagination);
  let url = `${PROMOTIONS_PATH}/${promoId}/reconciliation-files?source=${SOURCE_BO}&${paginationParams}`;

  if (companyId) {
    url += `&company_ids=${companyId}`;
  }

  const response = await apiStoresBOBFF.get<IPromotionDetailsResponse>(url);
  return response.data;
};

const exportPromotionDetails = async (promoId: string, fileId: string, companyId: string) => {
  const url = `${PROMOTIONS_PATH}/${promoId}/reconciliation-file/${fileId}/download?company_id=${companyId}&source=${SOURCE_BO}`;
  const response = await apiStoresBOBFF.get<any>(url);
  return response.data;
};

const create = async (promotionTitle: string) => {
  const url = `${PROMOTIONS_PATH}`;
  const response = await apiStoresBOBFF.post<INewPromotionResponse>(url, promotionTitle);
  return response.data;
};

const getStoresPromos = async (cuits: string[], pagination = DEFAULT_PAGINATION) => {
  let cuitList = getCuitList(cuits);
  const paginationParams = loadUrlParamsFromObject(pagination);
  let url = `${PROMOTIONS_PATH}?cuits=${cuitList}&${paginationParams}`;

  const response = await apiStoresBOBFF.get<IStoresPromotionResponse>(url);
  return response.data;
};

const getLiquidationSummary = async (reconciliationFileId, companyId) => {
  const url = `${COMPANY_POSITIONS_PATH}${LIQUIDATION_SUMMARY_PATH}?reconciliation_file_id=${reconciliationFileId}&company_id=${companyId}`;
  const response = await apiPromotionsBFF.get<ILiquidationSummary>(url);
  return response.data;
};

const getLiquidationFile = async (reconciliationFileId, companyId) => {
  const url = `reconciliation-files/${reconciliationFileId}/company/${companyId}/url_presigned_liquidation_file`;
  const response = await apiPromotionsBFF.get<ILiquidationFileInfo>(url);
  return response.data;
};

const promotionsServices = {
  findAll,
  findDetails,
  exportPromotionDetails,
  create,
  getStoresPromos,
  getLiquidationSummary,
  getLiquidationFile
};

export default promotionsServices;
